import { Form, Select } from "antd";
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
} from "react-beautiful-dnd";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import styled from "styled-components";
import { UI_LABELS } from "@lhd/constants";

export const DragHandleButton = styled.div`
  background-color: #1890ff;
  color: white;
  padding: 4px 8px;
  text-align: center;
  cursor: move;
  border-radius: 4px 0 0 4px;
  font-size: 12px;
  margin-right: 8px;
  min-width: 40px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Styles = styled.div`
  .label {
    margin-top: 1rem;
  }
  .inner {
    display: flex;
    flex-direction: column;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px;
      .left-handle {
        display: flex;
        align-items: center;
      }
      &:hover {
        background-color: #efefef;
      }
    }
  }
`;

const FieldsShownInLookupPicker = () => {
  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;
  };
  return (
    <Styles>
      <div className="label">検索ピッカーに表示されるフィルード</div>
      <div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" direction="vertical">
            {(provided: any) => (
              <div className="inner" ref={provided.innerRef}>
                <Form.List name="fields" initialValue={[{}]}>
                  {(fields: any[], { add, remove }: any) => (
                    <>
                      {fields.map(({ key, ...restField }, index) => (
                        <Draggable
                          key={restField.name}
                          draggableId={String(restField.name)}
                          index={restField.name}
                        >
                          {(providedDrag: any) => (
                            <div
                              className="item"
                              ref={providedDrag.innerRef}
                              {...providedDrag.draggableProps}
                              {...providedDrag.dragHandleProps}
                            >
                              <div className="left-handle">
                                <DragHandleButton>
                                  {UI_LABELS.DRAG_HANDLE}
                                </DragHandleButton>
                                <Select style={{ width: 300 }} />
                              </div>
                              <div>
                                <AiFillPlusCircle
                                  color="#ababab"
                                  size={18}
                                  onClick={() => add("add", index)}
                                />
                                {fields.length !== 1 && (
                                  <AiFillMinusCircle
                                    color="#ababab"
                                    size={18}
                                    onClick={() => remove(index)}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </>
                  )}
                </Form.List>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </Styles>
  );
};

export default FieldsShownInLookupPicker;
